import { CoreMenu } from '@core/types';

//? DOC: http://localhost:7777/demo/vuexy-angular-admin-dashboard-template/documentation/guide/development/navigation-menus.html#interface

export const menu: CoreMenu[] = [
  // Dashboard
  {
    id: 'dashboard',
    title: 'Dashboard',
    translate: 'MENU.DASHBOARD.COLLAPSIBLE',
    type: 'item',
    icon: 'home',
    url: "dashboard",
 
  },
 
  {
    id: 'settings',
    type: 'item',
    title: 'General Settings',
    translate: 'MENU.APPS.SECTION',
    icon: 'settings',
    url: "pages/general-settings",
    permission:[1]
  },
 
  {
    id: 'delivery-addresses',
    type: 'item',
    title: 'Manage Delivery Addresses',
    translate: 'MENU.UI.SECTION',
    icon: 'map',
    url:"pages/address-list",
    permission:[1]
  },
 
  {
    id: 'order-details',
    type: 'item',
    title: 'Manage Subscriptions',
    translate: 'MENU.CM.SECTION',
    icon: 'shopping-cart',
    url:"pages/subscription-list",
    permission:[1]
  },
  
  {
    id: 'payment-methods',
    type: 'item',
    title: 'Manage Payment Methods',
    translate: 'MENU.OTHERS.SECTION',
    icon: 'credit-card',
    url:"pages/payment-methods",
    permission:[1]
  },
  {
    id: 'upload-orders',
    type: 'item',
    title: 'Upload Orders',
    translate: 'MENU.OTHERS.SECTION',
    icon: 'upload-cloud',
    url:"pages/upload-orders",
    permission:[2]
  },
  {
    id: 'customer-orders',
    type: 'item',
    title: 'Orders',
    translate: 'MENU.OTHERS.SECTION',
    icon: 'search',
    url:"pages/customer-orders",
    permission:[2]
  }
];
